import { domainUrl } from '../constants';

export const API_GET_BLOCKS = `${domainUrl}blocks`;
export const API_CREATE_BLOCK = `${domainUrl}blocks`;
export const API_UPDATE_BLOCK = `${domainUrl}blocks/{id}`;
